export interface RevenueYear {
  year: string
  display: string
  exact: string
  /** Actual model value, used only to scale the bars honestly. */
  value: number
}

export const revenueYears: RevenueYear[] = [
  { year: 'Year 1', display: '$0.70M', exact: '$0.70M', value: 700000 },
  { year: 'Year 2', display: '$3.98M', exact: '$3.98M', value: 3980000 },
  { year: 'Year 3', display: '$10.77M', exact: '$10.77M', value: 10770000 },
]

export const yearThreeScale = [
  { value: '18,577', label: 'Paid app subscribers' },
  { value: '1,441', label: 'Active business customers' },
]

export const cashFlowMilestone = {
  when: 'Month 17',
  label: 'Operating cash-flow positive',
}

export const opportunityShare = {
  value: '~0.12%',
  lead: 'Year-3 revenue represents only',
  label: 'of the illustrative focused U.S. revenue opportunity ($9.23B)',
}

export const revenueEngines = [
  { name: 'VEXU App', model: 'Subscription + Usage' },
  { name: 'VEXU Business', model: 'Platform + Usage + Expansion' },
]

export const executionPath = [
  '$1.5M SAFE',
  'U.S. launch',
  'Scale VEXU App',
  'Expand VEXU Business',
  'Year-3 base case',
]
